import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit'
import '../../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'pd/'

const initialState = {
    masterData: [],
    PDDetails: [],
    draftPO: [],
    currentStock: [],
    isLoading: false,
    returnPONo: "",
    addEDLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getDraftPO = createAsyncThunk('PO/gdpo', async (_, thunkAPI) => {

    try {
        const result = await axios.get(API_URL + 'getDraftPO')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getPDDetails = createAsyncThunk('PO/gdprd', async (poID, thunkAPI) => {

    try {
        const result = await axios.get(API_URL + `getPDDetails/${poID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getPDMasterData = createAsyncThunk('PO/gaPD', async (_, thunkAPI) => {

    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getPDData = createAsyncThunk('PD/gvd', async (pdID, thunkAPI) => {
    try {
        console.log("Fetching PD Data for ID:", pdID);
        const result = await axios.get(`${API_URL}getpdData/${pdID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const createPDMaster = createAsyncThunk('PD/avmd', async (vData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, vData)
        return result.data

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const createPDDetail = createAsyncThunk('Pd/avdd', async (pdDetailData, thunkAPI) => {
    try {

        const result = await axios.post(API_URL + 'detail/', pdDetailData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const getCurrentStock = createAsyncThunk('Pd/gcs', async (_, thunkAPI) => {
    try {

        const result = await axios.get(API_URL + 'getCurrentStock')

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})


export const poSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.masterData = []
            state.currentStock = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getDraftPO.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDraftPO.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.draftPO = action.payload
            })
            .addCase(getDraftPO.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getPDMasterData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getPDMasterData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(getPDMasterData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(createPDMaster.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createPDMaster.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.returnPONo = action.payload
            })
            .addCase(createPDMaster.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload.PONo
            })
            .addCase(getPDData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getPDData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.PDDetails = action.payload.pd
            })
            .addCase(getPDData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(createPDDetail.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createPDDetail.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.PODetails = action.payload
            })
            .addCase(createPDDetail.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getCurrentStock.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getCurrentStock.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.currentStock = action.payload
            })
            .addCase(getCurrentStock.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = poSlice.actions

export default poSlice.reducer